import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StepperComponent, StepperData } from "./stepper.component";


@Component({
  selector: 'msh-steppers',
  imports: [StepperComponent],
  template: `
  <div class="flex items-center justify-center m-4">
    @for(step of steps; track step.step; let index = $index; let last = $last){
      <msh-stepper [step]="step" [isLast]="last" (click)="stepClicked.emit(step)"></msh-stepper>
    }
  </div>
  `,
  styles: ``
})
export class SteppersComponent {
  @Input() steps: StepperData[] = []
  @Output() stepClicked: EventEmitter<StepperData> = new EventEmitter();
}
